import React, { useState, useEffect, useContext } from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import FullScreenLoading from '../components/FullScreenLoading';
import { PageTemplate } from '../components/PageTemplate';
import { AppContext } from '../AppContext';

import { verifyToken, logout, getMe, getMyQaProfile } from '../services';
import ROLES from '../helpers/roles';

const RouteComp = props => {
  const { path, setPageTitle, roles, component: Component } = props;

  return (
    <Route
      path={path}
      render={routeProps => {
        return <Component setPageTitle={setPageTitle} roles={roles} {...props} {...routeProps} />;
      }}
    />
  );
};

const CustomRoute = withRouter(props => {
  const { component, permissions, path, route, pageTitle, label, fullScreen, ...rest } = props;
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(true);
  const {
    state: { roles, initialAppLoadComplete },
    dispatch,
  } = useContext(AppContext);
  const setPageTitle = title =>
    dispatch({
      type: 'UPDATE_PAGE_TITLE',
      pageTitle: title,
    });

  useEffect(() => {
    const currentUserToken = localStorage.getItem('token');

    const verifyUser = async () => {
      try {
        const publicRoute = !!['/login', '/invisioniq', '/redirect'].find(partialRoute => path.includes(partialRoute));

        if (publicRoute) {
          setVerified(true);
          setLoading(false);
          return;
        }

        const userInfo = await verifyToken(currentUserToken);
        const { name: accountName } = userInfo;
        const me = await getMe();
        const {
          identity: { userName, phoneNumber, email, id: userId },
          roles,
        } = me;

        let canProcessCancel = false;
        if (roles.includes(ROLES.QA)) {
          try {
            const qaProfile = await getMyQaProfile();
            canProcessCancel = !!qaProfile.canProcessCancel;
          } catch (error) {
            canProcessCancel = false;
          }
        }

        dispatch({
          type: 'SET_STATE',
          accountName: accountName || 'Account',
        });
        dispatch({
          type: 'UPDATE_ROLES',
          roles,
          canProcessCancel,
        });
        dispatch({
          type: 'UPDATE_ACCOUNT_INFO',
          username: userName,
          email,
          phoneNumber,
          userId,
          canProcessCancel,
        });
        setVerified(true);
      } catch (error) {
        logout();
        setVerified(false);
      } finally {
        setLoading(false);

        if (!initialAppLoadComplete) {
          dispatch({
            type: 'SET_INITIAL_APP_LOAD_COMPLETE',
            initialAppLoadComplete: true,
          });
        }
      }
    };

    setPageTitle(pageTitle || label);
    verifyUser();
  }, []);

  if (!initialAppLoadComplete) {
    return <FullScreenLoading />;
  }

  if (!loading && !verified) {
    return <Redirect to={'/login'} />;
  }

  if (fullScreen) {
    return <RouteComp roles={roles} verified={verified} loading={loading} setPageTitle={setPageTitle} {...props} />;
  }

  return (
    <PageTemplate {...rest} pageTitle={pageTitle}>
      <RouteComp roles={roles} loading={loading} verified={verified} setPageTitle={setPageTitle} {...props} />
    </PageTemplate>
  );
});

CustomRoute.propTypes = {};

export default CustomRoute;
